var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoManuales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:url(#SVGID_1_);stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.4016,
    y1: 44.8022,
    x2: 85.5764,
    y2: 44.8022
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7284FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#94DCF4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.28,63.66V23.68c0-2.55,2.07-4.62,4.62-4.62h16.78c3.84,0,6.96,3.12,6.96,6.96v41.52 c0-1.65-3.05-3.89-4.7-3.89H12.28z M49.67,19.06c-0.66,0-1.31,0-1.97,0c-3.87,0-7,3.12-7,6.96v41.52c0-1.65,3.07-3.89,4.73-3.89 c7.93,0,15.87,0,23.8,0c0-8.61,0-17.01,0-25.62 M12.28,64.18v2.19c0,1.54,1.25,2.79,2.79,2.79h51.36c1.54,0,2.79-1.25,2.79-2.79 v-2.19 M80.67,9.92H53.33c-2.02,0-3.66,1.64-3.66,3.66v12.81v7.89c0,0.27,0.03,0.54,0.09,0.79l0.14,9.5 c0.15,0.38,0.3,0.76,0.46,1.14c0.1,0.23,0.32,0.68,0.8,1.03c0.67,0.49,1.39,0.47,1.72,0.46c1.14-0.04,1.92-0.68,2.17-0.91l6.97-8.35 h18.65c2.02,0,3.66-1.64,3.66-3.66v-20.7C84.33,11.56,82.69,9.92,80.67,9.92z M57,17.81h19.44 M76.84,23.99L57,23.88 M57,30.28 l20.24-0.11 M18.12,32.22h16.92 M17.94,40.69h16.92 M17.94,48.92h16.92 M12.38,25.36c-1.17,0-2.02,0-3.19,0 c-1.96,0-3.54,1.59-3.54,3.54v43c0,0.98,0.4,1.87,1.04,2.51c1.01,1.01,2.27,1.04,2.51,1.04c9.19,0,18.37,0,27.56,0 M44.07,75.45 c9.3,0,18.6,0,27.9,0c3.52-2.05,3.54-3.31,3.54-3.54c0-11.4,0-22.58,0-33.98 M36.64,75.54v1.31c0,1.57,1.27,2.83,2.83,2.83h1.65 c1.57,0,2.83-1.27,2.83-2.83v-1.31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoManuales);
export default __webpack_public_path__ + "static/media/icono_manuales.5f335456cabf56b429e3f7d509ba2f7f.svg";
export { ForwardRef as ReactComponent };